import React from 'react';
import {Route, Routes} from 'react-router-dom';
import useQuery from '../../useQuery';
import Services from './Services';
import Service from './Service';
import Endpoints from './Endpoints';
import Endpoint from './Endpoint';
import Cart from './cart/Cart';
import RulesUk from './rules-uk';
import RulesEn from './rules-en';
import TermsUk from './terms-uk';
import TermsEn from './terms-en';
import PrivacyUk from './privacy-uk';
import PrivacyEn from './privacy-en';
import Faq from './Faq';
import Origin from '../theme/Origin';
import Shell from './Shell';
import {NotFoundWithShell} from '../not-found';

const RootRoutes = () => {
    const {locale = 'uk'} = useQuery();
    return (
        <Routes>
            <Route path='/' element={<Origin><Shell/></Origin>}>
                <Route path='services'>
                    <Route index element={<Services/>}/>
                    <Route path=':id' element={<Service/>}/>
                </Route>
                <Route path='endpoints'>
                    <Route index element={<Endpoints/>}/>
                    <Route path=':id' element={<Endpoint/>}/>
                </Route>
                <Route path='cart' element={<Cart/>}/>
                <Route path='rules' element={locale == 'uk' ? <RulesUk/> : <RulesEn/>}/>
                <Route path='terms' element={locale == 'uk' ? <TermsUk/> : <TermsEn/>}/>
                <Route path='privacy' element={locale == 'uk' ? <PrivacyUk/> : <PrivacyEn/>}/>
                <Route path='faq-deprecated' element={<Faq/>}/>
            </Route>
            <Route path='*' element={<NotFoundWithShell/>}/>
        </Routes>
    )
}

export default React.memo(RootRoutes);